import { Collapse } from '@mui/material';
import React, { FC, useRef } from 'react';

import { ComposeNodeType } from '../../containers/compose/props';
import MuiIcon from '../MUI/MuiIcon';

import useComposeActions from './hooks/useComposeActions';
import * as Styled from './styled';

type Props = {
  handleClick: () => void;
  nodeType: ComposeNodeType;
  shouldShow: boolean;
};

/**
 * A list of actions to show when open compose button is clicked
 *
 * @param props             Props passed to the component
 * @param props.handleClick Handle link click
 * @param props.nodeType    Type of the node (MESSAGE or TEMPLATE)
 * @param props.shouldShow  Whether to show the actions
 *
 * @returns                 Component itself
 */
const ComposeActions: FC<Props> = ({ handleClick, nodeType, shouldShow }) => {
  const actions = useComposeActions(nodeType);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  /**
   * Handle entering the content and focusing on wrapper
   */
  const handleContentEntered = () => {
    wrapperRef.current?.focus();
  };

  return (
    <Collapse
      in={shouldShow}
      mountOnEnter={true}
      onEntered={handleContentEntered}
      unmountOnExit={true}
    >
      <Styled.Wrapper ref={wrapperRef} role="menu" tabIndex={0}>
        {actions.map(({ url, icon, label }) => (
          <Styled.ComposeLink key={icon} onClick={handleClick} to={url}>
            <MuiIcon icon={icon} />
            {label}
          </Styled.ComposeLink>
        ))}
      </Styled.Wrapper>
    </Collapse>
  );
};

export default ComposeActions;
